import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import UploadButton from "../../DataImport/UploadButton/UploadButton";
import { getSafeSelectedWorkspace } from "../../../utils/mappers/user";
import { uploadEventFile } from "../../../actions/calendar";

import {
  Modal,
  Form,
  Header,
  Icon,
  Button,
  Confirm,
  Grid,
  Checkbox,
} from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import "./EventMultipleUpload.css";

export const EventMultipleUpload = ({ 
  currentWorkspaceId,
  uploadEventFile,
  onClose, 
}) => {
  const { t, i18n } = useTranslation();

  const onSave = (e) => {
    e.preventDefault();
    setShowRemoveEventConfirm(true)
    // onClose();
  };
  const [replaceEvents, setReplaceEvents] = useState(false);
  const [showRemoveEventConfirm, setShowRemoveEventConfirm] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputReferences = useRef();
 
  const openFileChooser = () => {
    fileInputReferences.current.click();
  };

  const onFileAdded = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
  }

  const sendUploadRequest = () => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    const params = {
      replace_events: replaceEvents
    }
    uploadEventFile(currentWorkspaceId, params, formData, i18n.language);
    onClose();
  }
  return (
    <>
      <Confirm
        open={showRemoveEventConfirm}
        content={t("calendar.events.uploadConfirmMessage", {
          event: selectedFile ? selectedFile.name : "",
        })}
        cancelButton={t("cancel")}
        confirmButton={t("confirm")}
        onCancel={() => setShowRemoveEventConfirm(false)}
        onClose={() => setShowRemoveEventConfirm(false)}
        onConfirm={sendUploadRequest}
      />
      <Form onSubmit={onSave}>
        <Modal
          as={Form}
          className="event-modal"
          open
          size="small"
          onClose={onClose}
        >
          <Header
            icon="browser"
            content={
              t("calendar.events.multipleEventUpload")
            }
          />
          <Modal.Content>
            <Grid>
              <Grid.Column>
                <Form.Field>
                    <Checkbox
                        label={{
                          children: t("calendar.events.replaceEvents"),
                          style: {fontWeight: "normal" },
                        }}
                        toggle
                        checked={replaceEvents}
                        onChange={() => setReplaceEvents(!replaceEvents)}
                        />
                </Form.Field>
              </Grid.Column>
            </Grid>
            
            <Grid columns={2}>
            <Grid.Column style={{width: "auto"}}>
            <Form.Field>
                <UploadButton
                    disabled={false}
                    align={"left"}
                    text={t('dataImport.uploadNew')}
                    fileInputRef={fileInputReferences}
                    openFileDialog={openFileChooser}
                    onFileAdded={onFileAdded}

                />
            </Form.Field>
            </Grid.Column>
            <Grid.Column style={{flex: 1, display: "flex", alignItems: "center"}}>
              {selectedFile ? (
                <span>{selectedFile.name}</span>
              ) : (
                <span style={{ opacity: 0.6 }}>{t("calendar.events.noFileSelected")}</span>
              )}
            </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Row>
                <Grid.Column className="calendar-event-file-info-section">
                  <div className="calendar-event-file-info-item">{t("calendar.events.eventFileDateInfo")}</div>
                  <div className="calendar-event-file-info-item">{t("calendar.events.eventFileTypeInfo")}</div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
          <Modal.Actions className="modal-actions-custom">
            <Button
              className="download-btn"
              // eslint-disable-next-line no-undef
              href={`${process.env.PUBLIC_URL}/excel_templates/${
                i18n.language
              }/${t("calendar.events.templateFilename")}.xlsx`}
              download
            >
              {t("calendar.events.templateButton")}
            </Button>

            <div className="right-buttons">
              <Button type="cancel" color="red" inverted onClick={onClose}>
                <Icon name="close" /> {t("cancel")}
              </Button>

              <Button color="green" inverted type="submit" disabled={!selectedFile}>
                <Icon name="checkmark" /> {t("save")}
              </Button>
            </div>
          </Modal.Actions>
        </Modal>
      </Form>
    </>
  );
};

EventMultipleUpload.propTypes = {
  currentWorkspaceId: PropTypes.number,
  uploadEventFile: PropTypes.func,
  onClose: PropTypes.func,
};

EventMultipleUpload.defaultProps = {
  currentWorkspaceId: 1,
  uploadEventFile: _.noop,
  onClose: _.noop,
};

const mapStateToProps = (state) => ({
  currentWorkspaceId: getSafeSelectedWorkspace(state),
});

export default connect(mapStateToProps,{
  uploadEventFile
})(EventMultipleUpload);
